import type { TranslationTable } from "@repo/shared/types";
import type { PdfComponentType } from "@/pages/settings/pdf-templates/detail/types";

/**
 * PDF component type labels, keyed by the language the flow/PDF templates are
 * authored in (not the advisor's UI language). Typed as `Record<PdfComponentType,
 * string>` per language so the compiler enforces completeness whenever the shared
 * `ALL_PDF_COMPONENT_TYPES` registry grows.
 */
export const T: TranslationTable<Record<PdfComponentType, string>> = {
  en_GB: {
    text: "Text",
    heading: "Heading",
    table_of_contents: "Table of Contents",
    image: "Image",
    advisor_image: "Advisor Image",
    page_break: "Page Break",
    spacer: "Spacer",
    table: "Table",
    portfolio_display: "Portfolio Display",
    portfolio_xray: "Portfolio X-Ray",
    asset_allocation: "Asset Allocation",
    asset_class_forecast: "Asset Class Forecast",
    portfolio_forecast: "Portfolio Forecast",
    historical_return: "Historical Return",
    expected_value: "Expected Value",
    risk_assessment: "Risk Assessment",
    cost_table: "Cost Summary",
    cost_chart: "Cost Chart",
    portfolio_costs: "Portfolio Costs",
    product_costs: "Product Costs",
    client_classification: "Client Classification",
    product_assessment: "Product Assessment",
    quiz_results: "Knowledge Quiz Results",
    trapets_lookup: "PEP/Sanction Check",
    sumsub_verification: "Sumsub ID Verification",
    enin_lookup: "Company Registry Check",
    group_members: "Group Members",
    client_parties: "Related Parties",
    goal_info: "Goal Information",
    goal_list: "Goal List",
    wealth_plan: "Wealth Plan",
    sustainability_preferences: "Sustainability Preferences",
    sustainability_status: "Sustainability Status",
    client_preferences: "Client Preferences",
    financial_situation: "Financial situation",
    volatility_chart: "Volatility Chart",
    equity_share_chart: "Equity Share Chart",
    mandate: "Mandate",
    mandate_comparison: "Mandate Changes",
    mandate_portfolio: "Mandate (Portfolio)",
  },
  nb_NO: {
    text: "Tekst",
    heading: "Overskrift",
    table_of_contents: "Innholdsfortegnelse",
    image: "Bilde",
    advisor_image: "Rådgiverbilde",
    page_break: "Sideskift",
    spacer: "Mellomrom",
    table: "Tabell",
    portfolio_display: "Porteføljevisning",
    portfolio_xray: "Portefølje X-Ray",
    asset_allocation: "Aktivaallokering",
    asset_class_forecast: "Aktivaklasseprognose",
    portfolio_forecast: "Porteføljeprognose",
    historical_return: "Historisk avkastning",
    expected_value: "Forventet verdi",
    risk_assessment: "Risikovurdering",
    cost_table: "Kostnadssammendrag",
    cost_chart: "Kostnadsdiagram",
    portfolio_costs: "Porteføljekostnader",
    product_costs: "Produktkostnader",
    client_classification: "Kundeklassifisering",
    product_assessment: "Produktvurdering",
    quiz_results: "Kunnskapsquiz-resultater",
    trapets_lookup: "PEP/Sanksjonssjekk",
    sumsub_verification: "Sumsub ID-verifisering",
    enin_lookup: "Selskapssjekk",
    group_members: "Gruppemedlemmer",
    client_parties: "Relaterte parter",
    goal_info: "Målinformasjon",
    goal_list: "Målliste",
    wealth_plan: "Formuesplan",
    sustainability_preferences: "Bærekraftspreferanser",
    sustainability_status: "Bærekraftsstatus",
    client_preferences: "Kundepreferanser",
    financial_situation: "Økonomisk situasjon",
    volatility_chart: "Volatilitetsdiagram",
    equity_share_chart: "Aksjeandelsdiagram",
    mandate: "Mandat",
    mandate_comparison: "Mandatendringer",
    mandate_portfolio: "Mandat (portefølje)",
  },
};
